/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconNavigationEast = createReactComponent("navigation-east", "IconNavigationEast", [
  ["path", { d: "M14 3h-4v6h4", key: "svg-0" }],
  ["path", { d: "M10 6h2.5", key: "svg-1" }],
  ["path", { d: "M16 21l-4 -8l-4 8l4 -2z", key: "svg-2" }]
]);

export { IconNavigationEast as default };
//# sourceMappingURL=IconNavigationEast.js.map
